"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteMajor = exports.updateMajor = exports.createMajor = exports.getMajorByAccessRole = exports.getMajorById = exports.getMajor = exports.MAJOR_BASE_URL = void 0;
const core_1 = require("@schoolbase/core");
const axios_1 = __importDefault(require("axios"));
const index_1 = require("./index");
exports.MAJOR_BASE_URL = (index_1.SRV_ENV || process.env.NODE_ENV === 'production') ?
    index_1.MajorBaseUrl : 'http://localhost:3006';
const majorUrl = `${exports.MAJOR_BASE_URL}${core_1.API_MAJOR}`;
async function getMajor(token) {
    const response = await axios_1.default.get(majorUrl, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        }
    });
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.getMajor = getMajor;
async function getMajorById(id, token) {
    const response = await axios_1.default.get(majorUrl + id, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        }
    });
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.getMajorById = getMajorById;
async function getMajorByAccessRole(access_role, token) {
    const response = await axios_1.default.get(majorUrl + "access_roles/" + access_role, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        }
    });
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.getMajorByAccessRole = getMajorByAccessRole;
async function createMajor(major) {
    const response = await axios_1.default.post(majorUrl, major);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.createMajor = createMajor;
async function updateMajor(id, major) {
    const response = await axios_1.default.put(majorUrl + id, major);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.updateMajor = updateMajor;
async function deleteMajor(id) {
    const response = await axios_1.default.delete(majorUrl + id);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.deleteMajor = deleteMajor;
